// src/api/hashtags.ts
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../lib/firebase';

export type HashtagData = {
  id: string;
  name?: string;
  normalizedName?: string;
  count?: number;
  boards?: string[];
  lastUsed?: any;
  createdAt?: any;
  [key: string]: any;
};

export const fetchHashtags = async (workspaceId: string): Promise<HashtagData[]> => {
  if (import.meta.env.MODE === 'development') {}
  
  const hashtagsCol = collection(db, `workspaces/${workspaceId}/hashtags`);
  
  if (import.meta.env.MODE === 'development') {}
  
  try {
    const qRef = query(hashtagsCol, orderBy('name', 'asc'));
    const snapshot = await getDocs(qRef);
    
    if (import.meta.env.MODE === 'development') {
      if (!snapshot.empty) {
        const firstDoc = snapshot.docs[0];
      }
    }

    const hashtags: HashtagData[] = [];
    snapshot.forEach((doc) => {
      const data = doc.data() as Omit<HashtagData, 'id'>;
      hashtags.push({ ...data, id: doc.id });
    });
    
    if (import.meta.env.MODE === 'development') {}
    return hashtags;
  } catch (error) {
    console.error('❌ [ERROR] fetchHashtags error:', error);
    throw error;
  }
};
